// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicyPage_container__NFWal","content":"PrivacyPolicyPage_content__ON4j4","link":"PrivacyPolicyPage_link__J-F75"};